import script from "./CityAutocompleteForEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./CityAutocompleteForEvent.vue?vue&type=script&setup=true&lang=js"

import "./CityAutocompleteForEvent.vue?vue&type=style&index=0&id=5d544e4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d544e4f"]])

export default __exports__